import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseTargetLocation } from "./UseTargetLocation";

export default function TargetAutoComplete(props) {
  const { getAllLocationList } = UseTargetLocation();
  const [productLocationRes, setProductLocationRes] = React.useState();
  const [selectedLocation, setSelectedLocation] = React.useState();

  useEffect(() => {
    getAllLocationList((targetLocations) => {
      setProductLocationRes(targetLocations);
    });
  }, []);

  useEffect(() => {
    if (productLocationRes && props.selectedTargetID) {
      setSelectedLocation(
        productLocationRes.targetLocations.find(
          (m) => m.id == props.selectedTargetID
        )
      );
    }
  }, [productLocationRes, props.selectedTargetID]);

  useEffect(() => {
    if (selectedLocation) {
      props.setter({
        ...props.lvl3State,
        targetLocationID: selectedLocation.id,
      });
    }
  }, [selectedLocation]);

  return productLocationRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.cluster && "100%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedLocation ? selectedLocation : ""}
        options={
          productLocationRes.targetLocations
            ? productLocationRes.targetLocations
            : []
        }
        getOptionLabel={(targetLocations) =>
          targetLocations.location ? targetLocations.location : ""
        }
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="محل مصرف" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.location ? option.location : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedLocation(newValue);
          } else {
            setSelectedLocation();
            props.setter({
              ...props.lvl3State,
              targetLocationID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllLocationList((targetLocations) => {
            setProductLocationRes(targetLocations);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/targetlocation" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
